import axios from 'axios'
// import qs from 'qs'
import { saveState, getSavedState, setDefaultAuthHeaders } from '@state/helpers'
import mapApiUrl from '@/src/utils/api-mapper'

export const state = {
  currentClientDetail: getSavedState('account.currentClientDetail'),
  clientList: [],
}

export const mutations = {
  SET_CURRENT_CLIENT_DETAIL(state, newValue) {
    state.currentClientDetail = newValue
    saveState('account.currentClientDetail', newValue)
  },
  SET_CLIENT_LIST(state, newValue) {
    state.clientList = newValue
  },
}

export const getters = {
  organizationList(state) {
    return state.clientList
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  // Set current client detail.
  setClientDetail({ commit }, detail) {
    commit('SET_CURRENT_CLIENT_DETAIL', detail)
  },
  setClientList({ commit }, list) {
    commit('SET_CLIENT_LIST', list)
  },

  getClientList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/org/list')
    return axios
      .get(url, { params: params })
      .then((response) => {
        const list = response.data.data
        list.content.forEach((element) => {
          element.isActive = element.isActive === 1
        })
        dispatch('setClientList', list.content)
        return response
      })
      .catch((err) => {
        console.log(err)
        dispatch('setClientList', [])
      })
  },

  addClient({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/org/add')
    const data = new FormData()
    const keys = Object.keys(params)
    for (const key of keys) {
      data.append(key, params[key])
    }
    return axios
      .post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return response
      })
  },

  updateClient({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/org/update')
    const data = new FormData()
    const keys = Object.keys(params)
    for (const key of keys) {
      data.append(key, params[key])
    }
    return axios
      .post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return response
      })
  },

  deleteClient({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/org/remove')
    return axios.delete(url, { params: params }).then((response) => {
      return response
    })
  },
}
